// eslint-disable-next-line import/prefer-default-export
export function loginStatus() {
  return !!document.cookie
    .split('; ')
    .find((row) => row.startsWith('access_token'))
}
